<template>
  <div class="card modal-card">
    <div class="modal-card-body pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px">
            <h1 class="title is-size-5">
              {{ $t('gestionAffectation.titlePopUpMultiAffectationCommande', { face: face }) }}
            </h1>
          </div>
        </div>
      </div>
      <div class="card-content">
        <div v-for="(commande, index) in commandes" :key="index">
          <div class="pd-10px has-text-centered mgt-5px mgb-0 columns
          is-paddingless">
            <router-link-blank class="column is-narrow pdb-0 pdt-0"
                               :to="{ name: 'c.bodac.commandes',
                    params: {id: commande.commandeId}}"
                               :message="commande.code"/>
            <div class="column is-narrow pd-0">-</div>
            <span class="column is-narrow pdb-0 pdt-0">
                {{ commande.annonceurs }}
            </span>
          </div>
          <hr class="mgl-20px mgr-20px" v-if="index + 1 !== commandes.length">
        </div>
        <div class="card-content center pdb-0">
          <div class="button" @click="$emit('close')">
            {{ $t('gestionAffectation.actions.close') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import routerLinkBlank from '@/components/general/routerLinkBlank';

export default {
  props: {
    commandes: {
      type: Array,
      required: true,
    },
    face: {
      type: String,
      required: true,
    },
  },
  components: {
    routerLinkBlank,
  },
};
</script>
